export const getSaveIssueChanges = (id: number) => `/issues/${id}/update/`;

export const getUrlLocationById = (id: number) => `/locations/${id}/`;
